import React, { Component } from 'react';
import * as axios from 'axios';
import PropTypes from 'prop-types';
import './njitEquipment.scss';

declare var jQuery: any;

class NjitEquipment extends Component {


  constructor(props) {
    super(props);
	this.accessTypes=['Standard Access','Assisted Use Only','Staff Use Only','Submit a Job'];
    this.state = {
	    page:1,
	    perpage:12,
		data:{
			hits:{
				total:1,
				hits:[]
			}
		},
		categories:{
			buckets:[]	
		},
		filters:{
		    category:this.props.category,
		    access_level:[]
	    },
		loaded:false
    };
    this.updateCats = this.updateCats.bind(this);
    this.updateAccess = this.updateAccess.bind(this);
    this.setPage = this.setPage.bind(this);
    
  }
  
  componentDidMount() {
	if(1){
		let paramsBody= {filters:this.state.filters, page: this.state.page, perpage: this.state.perpage};
		
		axios({
			method: 'POST',
			url: '//www.njitmakerspace.com/sites/njitmakerspace.com/equipment.php',
			headers: {
			'Content-Type': 'application/json'
			},
			data: JSON.stringify(paramsBody)
	    }).then((response) => {
		    console.log("xhr returned");
		    console.log(response.data);
			this.setState({ data: response.data.responses[0], categories: response.data.responses[1].aggregations.categories, loaded: true})
	      	
	    })
	    .catch((error) => {

	    });    
/*		let paramsBody = {
	      'from': (this.props.data.from)? parseInt(this.props.data.from, 10): 0,
	      'size': (this.props.data.size)? parseInt(this.props.data.size, 10): 4,
	      'query': {
	        'query_string': {
	          'query': (this.props.data.query)? this.props.data.query: '*',
	        }
	      }
	    };
		axios({
			method: 'POST',
			url: '/search-api/njitmakerspace/equipment/_search',
			headers: {
			'Content-Type': 'application/json'
			},
			data: JSON.stringify(paramsBody)
	    }).then((response) => {
			this.setState({ data: response.data})
	      	console.log(this.state);
	    })
	    .catch((error) => {

	    });    
	    */
	   }
	}    
 getHref(href) {
    //console.log(typeof href, href)
    if(typeof href === 'string'){
      return href;
    } else {
      return '#';  
    }
    
  }
   espaceChars(text) {
    return text.replace(/"/g, '&quot;');
  }
  updateCats(event){
	var target = event.target;
  //  const value = target.type === 'checkbox' ? target.checked : target.value;
   // const name = target.name;
   var temp= this.state.filters.category;
   	if(target.checked){
   		temp.push(target.value);
   	}else{
	   	var index = temp.indexOf(target.value);
		if (index > -1) {
		  temp.splice(index, 1);
		}
   	}
	this.setState({filters:{category:temp, access_level:this.state.filters.access_level}});
	this.componentDidMount()
  }
  updateLevel(event){
  	var target = event.target;
  	var temp= this.state.filters.access_level;
  	console.log(this.state);
   	if(target.checked){
   		temp.push(target.value);
   	}else{
	   	var index = temp.indexOf(target.value);
		if (index > -1) {
		  temp.splice(index, 1);
		}
   	}
	this.setState({filters:{category: this.state.filters.category, access_level:temp}});
	this.componentDidMount()
  }
  updateAccess(event){
  	var target = event.target;
  	var temp= this.state.filters.access_level;
  	console.log(this.state);
   	if(target.checked){
   		temp.push(target.value);
   	}else{
	   	var index = temp.indexOf(target.value);
		if (index > -1) {
		  temp.splice(index, 1);
		}
   	}
	this.setState({filters:{category: this.state.filters.category, access_level:temp}});
	this.componentDidMount()
  }
  backgroundImage(url)
  {
	  return {
		  backgroundImage: 'url(' + url + ')',
	  }
  }
  availability(input)
  {
	  if(typeof(input) === 'object'){
		 let output;
		  switch(input.value){
			  case 'Operational':
			  	output=  <i className="status status-green"></i> ;
			  	break;
			  case 'Service Advisory':
			  	output= <i className="status status-yellow"></i> ;
			  	break;
			  case 'Temporarily Unavailable':
			  	output= <i className="status status-red"></i> ;
			  	break;
			  default:
			  	output= <i className="status"></i>;
		  }
		  
		  return ( 
			  <div className="access">
		  	{output} {input.value}
		  	</div>
		  );
	  }
	  return '';
  }
  hazardClass(input)
  {
	  if(typeof(input) === 'string'){
		 let output;
		  switch(input){
			  case 'Hazard Class 1':
			  	output=  <i className="status status-green"></i> ;
			  	break;
			  case 'Hazard Class 2':
			  	output= <i className="status status-yellow"></i> ;
			  	break;
			  case 'Hazard Class 3':
			  	output= <i className="status status-orange"></i> ;
			  	break;
			  case 'Hazard Class 4':
			  	output= <i className="status status-red"></i> ;
			  	break;
			  default:
			  	output= <i className="status"></i> ;
		  }
		  
		  return ( 
			  <div className="access">
		  	{output} {input}
		  	</div>
		  );
	  }
	  return '';
  }
  accessType(input)
  {
	  if(typeof(input) === 'string'){
		 let output;
		  switch(input){
			  case 'Standard Access':
			  	output=  <i className="status status-green"></i> ;
			  	break;
			  case 'Assisted Use Only':
			  	output= <i className="status status-yellow"></i> ;
			  	break;
			  case 'Staff Use Only':
			  	output= <i className="status status-red"></i> ;
			  	break;
			  case 'Submit a Job':
			  	output= <i className="status status-red"></i> ;
			  	break;
			  default:
			  	output= <i className="status"></i> ;
		  }
		  
		  return ( 
			  <div className="access">
		  	{output} {input}
		  	</div>
		  );
	  }
	  return '';
  }  

  setPage(event)
  {
	  console.log('input: '+event.target.id);
	  const page_num=event.target.id;
	  console.log("set page: "+page_num+"\ncurrent page: "+this.state.page);
	  if(page_num !== this.state.page){
	 	 this.setState({page:page_num});
	 	 console.log(this.state);
	 	 this.componentDidMount()
	  }
  }
  isSelected(value)
  {
	  return this.props.category.indexOf(value)>-1;
  }
  	render() {
	  	console.log("render called");
	  	console.log(this.props);
	  	var pages = Math.ceil(this.state.data.hits.total/12);
	  	const pageNumbers = [];
	    for (let i = 1; i <= pages; i++) {
	      pageNumbers.push(i);
	    }
	  	
	  	if(!this.state.loaded)
	  	{
		  		return (
				<div className="equipment-wrapper">
		  
					<div className="filterbar">
						<div className="mobile-filter-trigger">Filters</div>
					</div>
					<div className="filters">
						<label>Categories</label>
						<div className="filterset">
						</div>
						<label>Access</label>
						<div className="filterset">
						</div>
			        </div>
			        <div className="items">
						<div className="la-ball-grid-pulse">
							<div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						</div>
					</div>
				</div>
				); 
	  	}
	  	let output = this.state.data.hits.hits.map((d,i) => {
	  	
	  	return ( <a key={i} href={this.getHref(d._source.base_url+d._source.alias)}>
	                    <div className="item">
	                            <div className="picture" style={this.backgroundImage(d._source.image_medium)} alt={'image of '+d._source_title}/>
	                            <div className="item-title" >{d._source.title}</div>
	                            {this.availability(d._source.availability)}
								{this.hazardClass(d._source.hazard_class[0].name)}
	                            {this.accessType(d._source.access_type_terms[0])}
	                    </div>
	                </a>)
	    });
	    return (
		  <div className="equipment-wrapper">
		  
		  	<div className="filterbar">
		  		<div className="mobile-filter-trigger">Filters</div>
		  	</div>
		  	  <div className="filters">
		  	  <label>Categories</label>
	          	<div className="filterset">
	          		
	          		<form>
	          		{this.state.categories.buckets.map((d,i) =>
		          		<div key={i}>
		          			<label>
		          				<input name="cat[]" type="checkbox" onChange={this.updateCats} value={d.key} checked={this.isSelected(d.key)} /> {d.key} ({d.doc_count}) 
		          			</label>
		          		</div>
	          		)}
	          		</form>
	          	</div>
	          	<label>Access</label>
	          	<div className="filterset">
	          		{this.accessTypes.map((d,i) =>	          	
		          		<div key={i}>
		          			<label>
		          				<input name="cat[]" type="checkbox" onChange={this.updateAccess} value={d} /> {d} 
		          			</label>
		          		</div>
		          	)}	          		
	          	</div>
	          	{this.state.filters.access_level}
	          	          	
	          	
	          </div>

		      <div className="items">
	              {output}
	              
	          </div>
          </div>
	    );
  	}
}

/*
	
	<div className="pager"><ul>
	              	{pageNumbers.map(number =>
		              	<li
				          key={number}
				          id={number}
				          onClick={this.setPage}
				        >
				          {number}
				        </li>
		              	)}</ul>
	              </div>
	              */



NjitEquipment.propTypes = {
  category: PropTypes.array,

};

export default NjitEquipment;








// WEBPACK FOOTER //
// ./src/Equipment/njitEquipment.js